var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 50,
    viewBox: "0 0 1 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 50,
    height: 1,
    transform: "rotate(-90 0 50)",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeperator);
export default __webpack_public_path__ + "static/media/Seperator.cecd98a9823e46ac268bb05fedf9ce6c.svg";
export { ForwardRef as ReactComponent };